import { NotificationRenderer } from '@components/Notifications';
import { toast } from 'react-toastify';

export class NotificationMessage {
  static defaultOptions = {
    containerId: 'notification',
  };

  static success = (message, iconType, options = {}) => {
    const finalOptions = Object.assign(options, this.defaultOptions);
    const notificationProps = { message, iconType };
    toast.success(
      <NotificationRenderer {...notificationProps} />,
      finalOptions,
    );
  };

  static error = (message, iconType, options = {}) => {
    const finalOptions = Object.assign(options, this.defaultOptions);
    const notificationProps = { message, iconType };
    toast.error(<NotificationRenderer {...notificationProps} />, finalOptions);
  };

  static warning = (message, iconType, options = {}) => {
    const finalOptions = Object.assign(options, this.defaultOptions);
    const notificationProps = { message, iconType };
    toast.warn(<NotificationRenderer {...notificationProps} />, finalOptions);
  };

  static info = (message, iconType, options = {}) => {
    const finalOptions = Object.assign(options, this.defaultOptions);
    const notificationProps = { message, iconType };
    toast.info(
      <NotificationRenderer defaultNotification {...notificationProps} />,
      finalOptions,
    );
  };
}
